/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/prop-types */
/* eslint-disable react/button-has-type */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import server from '../_api/backend';
import * as toast from '../_store/slice/toast';

type UserInfoProps = {
  userinfo?: { name: string; username: string };
  props?: RouteComponentProps;
};
export function Signup(paramData: UserInfoProps) {
  const dispatch = useDispatch();
  const [searchIdVisable, setSearchIdVisable] = useState<boolean>(false);
  const [searchAddrVisable, setSearchAddrVisable] = useState<boolean>(false);
  const [addrKeyword, setAddrKeyword] = useState<string>('');
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [items, setItems] = useState<any[]>([]);

  const { userinfo } = paramData;

  const [myInfoType, setMyInfoType] = useState<boolean>();

  const [name, setName] = useState<any>('');
  const [usernamePass, setUserNamePass] = useState<string>('false');
  const [username, setUserName] = useState<any>('');
  const [part, setPart] = useState<string>('normal');
  const [password, setPassword] = useState<any>('');
  const [password2, setPassword2] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [post, setPost] = useState<string>('');
  const [college, setCollege] = useState<string>('');
  const [department, setDepartment] = useState<string>('');

  const [address, setAddress] = useState<string>('');
  const [addressDetail, setAddressDetail] = useState<string>('');
  const [tel1, setTel1] = useState<string>('');
  const [tel2, setTel2] = useState<string>('');
  const [tel3, setTel3] = useState<string>('');
  const [cellPhone1, setCellPhone1] = useState<string>('');
  const [cellPhone2, setCellPhone2] = useState<string>('');
  const [cellPhone3, setCellPhone3] = useState<string>('');

  useEffect(() => {
    setMyInfoType(userinfo === undefined);
    if (userinfo !== undefined) {
      setName(userinfo.name);
      setUserName(userinfo.username);
      getUserInfo();
    }
  }, []);

  useEffect(() => {
    searchPostcode().then(() => {});
  }, [currentPage]);

  const history = useHistory();

  const param = {
    name,
    username,
    email,
    part,
    password,
    post,
    address: `${address} ${addressDetail}`,
    tel: `${tel1}-${tel2}-${tel3}`,
    phone: `${cellPhone1}-${cellPhone2}-${cellPhone3}`,
    college,
    department,
  };

  const param2 = {
    part,
    password,
    email,
    tel: `${tel1}-${tel2}-${tel3}`,
    phone: `${cellPhone1}-${cellPhone2}-${cellPhone3}`,
    address: `${address} ${addressDetail}`,
    college,
    department,
  };

  const idRule = /^[A-Za-z0-9]{1,10}$/;
  const passRule = /^[A-Za-z0-9]{6,12}$/;
  const emailRule = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
  const cellPhoneRule = /^\d{3}-\d{3,4}-\d{4}$/;

  // Validation
  const onClickSignup = () => {
    if (part.length <= 0) {
      dispatch(toast.error({ message: '구분 선택은 필수입니다.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (name.length <= 0) {
      dispatch(toast.error({ message: '이름을 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (name.length > 10) {
      dispatch(
        toast.error({
          message: '이름이 입력 최대치를 초과하였습니다. (10자 이내)',
          title: '필수 입력 최대치 초과',
        })
      );
      return;
    }
    if (username.length <= 0 || !idRule.test(username)) {
      dispatch(toast.error({ message: '아이디를 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (username.length > 10) {
      dispatch(
        toast.error({
          message: '아이디가 입력 최대치를 초과하였습니다. (10자 이내)',
          title: '필수 입력 최대치 초과',
        })
      );
      return;
    }
    if (usernamePass === 'false' && userinfo === undefined) {
      dispatch(
        toast.error({
          message: '아이디(ID) 입력란을 클릭하세요.',
          title: '아이디 중복 여부 필요',
        })
      );
      return;
    }
    if (password.length <= 0 || !passRule.test(password)) {
      dispatch(toast.error({ message: '비밀번호를 확인하세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (password !== password2) {
      dispatch(
        toast.error({ message: '비밀번호가 서로 같아야 합니다.', title: '필수 입력 항목 누락' })
      );
      return;
    }
    if (password.length > 12 || password2.length > 12) {
      dispatch(
        toast.error({
          message: '비밀번호가 입력 최대치를 초과하였습니다. (12자 이내)',
          title: '필수 입력 최대치 초과',
        })
      );
      return;
    }
    if (email.length <= 0 || !emailRule.test(email)) {
      dispatch(toast.error({ message: '이메일을 확인하세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (email.length > 40) {
      dispatch(
        toast.error({
          message: '이메일이 입력 최대치를 초과하였습니다. (40자 이내) 확인해주세요.',
          title: '필수 입력 항목 최대치 초과',
        })
      );
      return;
    }
    if (address.length <= 0) {
      dispatch(toast.error({ message: '주소를 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (address.length > 90) {
      dispatch(
        toast.error({
          message: '주소의 입력 최대치를 초과하였습니다. (90자 이내)',
          title: '필수 입력 항목 최대치 초과',
        })
      );
      return;
    }
    if (!cellPhoneRule.test(param.phone)) {
      dispatch(toast.error({ message: '휴대전화 확인하세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    registerMember();
  };

  // 회원가입 / 회원정보변경 API 호출
  const registerMember = async () => {
    if (myInfoType) {
      await server
        .signup(param)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            dispatch(toast.info({ message: '회원가입이 완료되었습니다.' }));
            history.push('/');
            history.push('/login');
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    } else {
      await server
        .patchUserInfo(param2)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            dispatch(toast.info({ message: '회원정보가 수정되었습니다.' }));
            paramData.props?.history.push('/');
          }
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });
    }
  };

  // 아이디(ID) 검사
  function validation() {
    if (username.length <= 0 || !idRule.test(username)) {
      dispatch(
        toast.error({
          message: '아이디(ID)를 확인해 주시기 바랍니다.',
        })
      );
      return false;
    }
    return true;
  }

  // 취소 버튼 클릭 시
  const onClickCancel = () => {
    history.go(-1);
  };

  // 로그인한 회원정보 조회 API 호출
  const getUserInfo = async () => {
    try {
      await server.getUserOwn().then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setCollege(payload.college);
          setDepartment(payload.department);
          setPart(payload.part);
          setEmail(payload.email);
          setAddress(payload.address);
          setTel1(payload.tel.split('-')[0]);
          setTel2(payload.tel.split('-')[1]);
          setTel3(payload.tel.split('-')[2]);
          setCellPhone1(payload.phone.split('-')[0]);
          setCellPhone2(payload.phone.split('-')[1]);
          setCellPhone3(payload.phone.split('-')[2]);
        }
      });
    } catch (error) {
      history.push('/login');
    }
  };

  // 사용자 구분 (교수 선택 시 대학명, 학과 입력란 추가됨)
  function professorAddon(data: string) {
    if (data === 'normal') {
      const inputProfessor = document.querySelectorAll('.input-professor');
      inputProfessor.forEach((input) => {
        input.classList.remove('active');
      });
    } else {
      const outputProfessor = document.querySelectorAll('.input-professor');
      outputProfessor.forEach((input) => {
        input.classList.add('active');
      });
    }
  }

  // 아이디 중복 확인 검색 API 호출
  const searchUserNameTemp = async () => {
    if (validation()) {
      if (username.length !== 0) {
        await server
          .searchUserName(1, 1, username)
          .then((payload) => {
            if (!payload) {
              dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
            } else if (payload.code === 260 || payload.code === 500) {
              dispatch(toast.error({ message: '파라미터 오류' }));
            } else {
              console.log('');
              if (payload.meta.itemCount === 0) {
                dispatch(toast.info({ message: '사용 가능한 아이디(ID)입니다.' }));
                setUserNamePass('true');
              } else {
                dispatch(toast.error({ message: '이미 사용 중인 아이디(ID)입니다.' }));
                setUserNamePass('false');
              }
            }
          })
          .catch((error) => {
            dispatch(
              toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
            );
            console.log(error);
          });
      }
    }
  };

  // 주소(우편번호) 검색 API 호출
  const searchPostcode = async () => {
    if (addrKeyword.length > 0) {
      await server
        .getPostcode(currentPage, 100, addrKeyword)
        .then((payload) => {
          if (!payload) {
            dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
          } else if (payload.code === 260 || payload.code === 500) {
            dispatch(toast.error({ message: '파라미터 오류' }));
          } else {
            setItems(payload.items);
            setCurrentPage(payload.currentPage);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  // 주소 테이블 생성
  function createAddressList() {
    return (
      <div className="table">
        <ul className="row title">
          <li>우편번호</li>
          <li>주소</li>
        </ul>
        {addressRow}
      </div>
    );
  }

  // 주소값 불러오기
  const addressRow = items?.map((item: any) => (
    <ul
      className="row"
      key={Math.random()}
      onClick={() => {
        setAddress(item.jibunAddr);
        setPost(item.zipNo);
        setSearchAddrVisable(false);
      }}
    >
      <li>{item.zipNo}</li>
      <li>
        <div>지번 : {item.jibunAddr}</div>
        <div>도로명 : {item.roadAddrPart1}</div>
      </li>
    </ul>
  ));

  // 회원탈퇴 페이지로 이동
  const onClickSignout = () => {
    history.push('/signout');
  };

  // Signup 리턴값
  return (
    <>
      <main className="sub wrapper">
        <div className="content">
          <div className="breadscrumb">
            <>Home</>
            {' > '}
            {myInfoType ? (
              <span />
            ) : (
              <>
                <span>회원정보</span>
              </>
            )}
            {myInfoType ? (
              <span />
            ) : (
              <>
                <span>{' > '}</span>
              </>
            )}
            <>{myInfoType ? <span>회원가입</span> : <span>마이페이지</span>}</>
          </div>
          <div className="title">
            {myInfoType ? <h2>회원가입</h2> : <h2>마이페이지</h2>}
            {myInfoType ? (
              <p>도서출판 구민사는 오랫동안 사랑받아온 신기술서적 출판사입니다.</p>
            ) : (
              <p>회원님의 정보를 확인 및 수정하는 페이지입니다.</p>
            )}
          </div>
          <section>
            <ul className="inputs">
              <li>
                <span className="required">구분</span>
                <div>
                  <input
                    type="radio"
                    id="userNormal"
                    name="userType"
                    value="normal"
                    onChange={(event) => {
                      setPart(event.target.value);
                      professorAddon('normal');
                    }}
                    defaultChecked={part === 'normal'}
                  />
                  <label htmlFor="userNormal">일반</label>
                  <input
                    type="radio"
                    id="userProfessor"
                    name="userType"
                    value="professor"
                    defaultChecked={part === 'professor'}
                    onChange={(event) => {
                      setPart(event.target.value);
                      professorAddon('professor');
                    }}
                  />
                  <label htmlFor="userProfessor">교수</label>
                </div>
              </li>
              <li className="input-professor">
                <span className="required">대학명</span>
                <input
                  type="text"
                  maxLength={30}
                  defaultValue={college}
                  onChange={(event) => {
                    setCollege(event.target.value);
                  }}
                />
              </li>
              <li className="input-professor">
                <span className="required">학과</span>
                <input
                  type="text"
                  maxLength={30}
                  defaultValue={department}
                  onChange={(event) => {
                    setDepartment(event.target.value);
                  }}
                />
              </li>
              <li>
                <span className="required">이름</span>
                <input
                  type="text"
                  value={name}
                  maxLength={10}
                  readOnly={name !== '' && !myInfoType}
                  onChange={(event) => {
                    setName(event.target.value);
                  }}
                />
              </li>
              <li className="get-id">
                <span className="required">아이디(ID)</span>
                <input
                  type="text"
                  maxLength={10}
                  readOnly={username !== '' && !myInfoType}
                  value={username}
                  onChange={(event) => {
                    setUserName(event.target.value);
                  }}
                  onFocus={() => {
                    if (userinfo === undefined) {
                      setSearchIdVisable(true);
                    }
                  }}
                />
                <small>
                  ID는 영문, 숫자 조합으로 10자리 이내로 하며, 특수문자는 사용 불가합니다.
                </small>
              </li>
              <li>
                <span className="required">비밀번호</span>
                <input
                  type="password"
                  maxLength={12}
                  value={password}
                  onChange={(event) => {
                    setPassword(event.target.value);
                  }}
                />
                <small>영문과 숫자를 혼용 6~12자리로 하며, 특수문자는 사용 불가합니다.</small>
              </li>
              <li>
                <span className="required">비밀번호 확인</span>
                <input
                  type="password"
                  maxLength={12}
                  value={password2}
                  onChange={(event) => {
                    setPassword2(event.target.value);
                  }}
                />
              </li>
              <li>
                <span className="required">이메일</span>
                <input
                  type="email"
                  maxLength={40}
                  value={email}
                  onChange={(event) => {
                    setEmail(event.target.value);
                  }}
                />
              </li>
              <li>
                <span className="required">주소</span>
                <div className="address-div-short">
                  <input
                    className="address-short"
                    maxLength={45}
                    value={address}
                    onChange={(event) => {
                      setAddress(event.target.value);
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => {
                      setSearchAddrVisable(true);
                    }}
                  >
                    주소검색
                  </button>
                </div>
              </li>
              <li className="address">
                <span>상세주소</span>
                <input
                  type="text"
                  value={addressDetail}
                  maxLength={45}
                  onChange={(event) => {
                    setAddressDetail(event.target.value);
                  }}
                />
              </li>
              <li className="phone">
                <span>전화번호</span>
                <div>
                  <input
                    type="number"
                    value={tel1}
                    maxLength={4}
                    onChange={(event) => {
                      setTel1(event.target.value);
                    }}
                  />
                  <span>-</span>
                  <input
                    type="number"
                    value={tel2}
                    maxLength={4}
                    onChange={(event) => {
                      setTel2(event.target.value);
                    }}
                  />
                  <span>-</span>
                  <input
                    type="number"
                    value={tel3}
                    maxLength={4}
                    onChange={(event) => {
                      setTel3(event.target.value);
                    }}
                  />
                </div>
              </li>
              <li className="phone">
                <span className="required">휴대폰</span>
                <div>
                  <input
                    type="number"
                    maxLength={4}
                    value={cellPhone1}
                    onChange={(event) => {
                      setCellPhone1(event.target.value);
                    }}
                  />
                  <span>-</span>
                  <input
                    type="number"
                    maxLength={4}
                    value={cellPhone2}
                    onChange={(event) => {
                      setCellPhone2(event.target.value);
                    }}
                  />
                  <span>-</span>
                  <input
                    type="number"
                    maxLength={4}
                    value={cellPhone3}
                    onChange={(event) => {
                      setCellPhone3(event.target.value);
                    }}
                  />
                </div>
              </li>
            </ul>
            <div className="buttons">
              <button className="btn-sub" onClick={onClickCancel}>
                취소
              </button>
              {!myInfoType && (
                <button className="btn-sub" onClick={onClickSignout}>
                  회원탈퇴
                </button>
              )}
              <button className="btn-main" onClick={onClickSignup}>
                {myInfoType ? <span>회원가입</span> : <span>변경하기</span>}
              </button>
            </div>
          </section>
        </div>

        <div className={`modal modal-get-id ${searchIdVisable && 'active'}`}>
          <header>
            <div className="title">
              <h3>아이디 확인</h3>
              <svg
                className="close"
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 18 18"
                onClick={() => {
                  setSearchIdVisable(false);
                }}
              >
                <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" />
              </svg>
            </div>
            <section>
              <p>사용하고자 하는 아이디를 입력하여 주세요.</p>
            </section>
            <section className="search">
              <input
                className="get-id"
                type="text"
                maxLength={10}
                value={username}
                onChange={(dom) => {
                  setUserName(dom.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    searchUserNameTemp();
                  }
                }}
              />
              <button
                type="button"
                onClick={() => {
                  searchUserNameTemp();
                }}
              >
                검색
              </button>
            </section>
          </header>
          <div className="modal-content">
            <section className="result">
              <button
                className="btn-main"
                type="button"
                onClick={() => {
                  if (validation()) {
                    if (usernamePass === 'true') {
                      setUserName(username);
                      setSearchIdVisable(false);
                    } else {
                      dispatch(toast.error({ message: '이미 사용중인 아이디(ID)입니다.' }));
                    }
                  }
                }}
              >
                사용하기
              </button>
            </section>
          </div>
        </div>
        <div className={`overlay ${searchIdVisable && 'active'}`} />

        <div className={`modal modal-address ${searchAddrVisable && 'active'}`}>
          <header>
            <div className="title">
              <h3>주소 찾기</h3>
              <svg
                className="close"
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                viewBox="0 0 18 18"
                onClick={() => {
                  setSearchAddrVisable(false);
                }}
              >
                <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" />
              </svg>
            </div>
            <section>
              <p>검색어(도로명,건물명,지번)를 입력해주세요(지번+도로명 통합 검색)</p>
            </section>
            <section className="search">
              <input
                type="text"
                value={addrKeyword}
                onChange={(event) => {
                  setAddrKeyword(event.target.value);
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    searchPostcode();
                  }
                }}
                maxLength={45}
                placeholder='예) "서소문로 26" 또는 "중림동 157-2'
              />
              <button
                onClick={() => {
                  searchPostcode();
                }}
              >
                검색
              </button>
            </section>
          </header>
          <div className="modal-content">
            <div className="address-results">
              <div className="content">{createAddressList()}</div>
            </div>
          </div>
        </div>
        <div className={`overlay ${searchAddrVisable && 'active'}`} />
      </main>
    </>
  );
}
